import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  defaultAssets: {
    font: false
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: "#241B5A",
        secondary: "#e8ecfa",
        accent: "#14132F",
        error: "#fd397a",
        info: "#5578eb",
        success: "#0abb87",
        warning: "#ffb822"
      }
    }
  }
});
